import { get, put } from "../api_helper"
import { getApiConfig } from "../authHelper"
import { APP_CONSTANT } from "../url_helper"

export const getAppConstant = () => get(APP_CONSTANT, getApiConfig())
export const updateAppConstant = data => put(APP_CONSTANT, data, getApiConfig())
